const gtm = {
  event: {
    resilienceModule: 'resilience_like_dislike',
    media: 'media_like_dislike',
    login: 'login',
    signUp: 'signup',
    audioPlayer: 'audio_controls',
    TakeAssessment: 'take_assessment',
    AddNewInsight: 'add_new_insight',
    AddNewIntention: 'add_new_intention',
    singleMediaOfMudule: 'module_audio',
    journalDataSave: 'save_journal',
    help: 'submit_question',
    profile: 'profile_update',
    resetPassword: 'reset_password',
    resendEmail: 'resend_email',
    updatePassword: 'update_password',
    compareAssessment: 'compare_assessment',
    nextModule: 'next_module',
    learnMore: 'learn_more',
    cookie: 'cookie_accept',
    payment: 'plan_upgrade',
    applyPromoCode: 'apply_promocode',
    ListenPSPAudio: 'listen_session_practices_audio',
    deleteIntention: 'delete_intention',
    notifications: 'notifications',
    unreadNotifications: 'read_particular_notification',
    laResult: 'la_result',
    selectPendingLA: 'select_pending_la',
    submitLARequest: 'submit_la_request',
    submitManagerRequest: 'submit_direct_manager_feedback_request',
    submitReminderRequest: 'submit_simple360_reminder_request',
    submitLAReminderRequest: 'submit_leader_reminder_request',
    submitReviewUpcomingQuest: 'submit_review_upcoming_quest',
    sessionDetails: 'session_details',
    sessionKeySkills: 'session_key_skills',
    userJourneysAudio: 'coach_recommends_audio',
    //orgJourneysAudio: 'org_journeys_audio',
    groupJourneysAudio: 'group_coach_recommends_audio',
    practicalOrPoeticAudio: 'practical_or_poetic_audio',
    keySkills: 'key_skills',
    moduleAudio: 'module_audio_like_dislike',
    favoritedAudioDislike: 'favorited_audio_dislike',
    surveyCategoryDetails: 'survey_category_details',
    laLearnMoreBtn: 'la_learn_more',
    toggleModuleFavorite: 'module_like_dislike',
    openAssessmentTypeform: 'open_assessment_typeform',
    upgradeButton: 'upgrade_button_clicked',
    openContinueProgram: 'open_continue_program',
    openProgram: 'open_program',
    playMediaLibraryAudio: 'play_medialibrary_audio',
    playFavoritedAudio: 'play_favorited_audio',
    playLRAudio: 'play_learning_resource_audio',
    playLRVideo: 'play_learning_resource_video',
    packingList: 'packing_list',
    toggleSessionMediaBookmark: 'toggle_session_media_bookmark',
    toggleCoachRecommendsMediaBookmark: 'toggle_journeys_media_bookmark',
    toggleLRMediaBookmark: 'toggle_learning_resource_bookmark',
    restoreIntention: 'restore_intention',
    addIntention: 'add_intention',
    archiveIntention: 'archive_intention',
    takeLeaderAssessment: 'take_leader_assessment',
    openLARequestsSentUserModal: 'open_la_request_sent_user_modal',
    playJournalMedia: 'play_journal_media',
    programEnrollBtnClicked: 'program_enroll_btn_clicked',
    togglePlayBarSize: 'toggle_playbar_size',
    openMediaDescription: 'open_media_description',
    bookCircle: 'book_circle',
    selectCoachAndCircleTime: 'select_coach_and_circle_time',
    scheduleSession: 'schedule_session',
    seeFullResult: 'see_full_result_assessment',
    readLearningResource: 'read_lr_tab',
    listenLearningResource: 'listen_lr_tab',
    watchLearningResource: 'watch_lr_tab',
    // Experience related events
    openExperiencePage: 'open_experience_page',
    openYourExperiencePage: 'open_your_experience_page',
    viewExperienceDetails: 'view_experience_details',
    viewExperienceItinerary: 'view_experience_itinerary',
    viewExperiencePayment: 'view_experience_payment',
    viewExperienceIntention: 'view_experience_intention',
    viewExperienceOrientationCall: 'view_experience_orientation_call',
    viewExperienceBookIndividualSession:
      'view_experience_book_individual_session',
    selectPreparationSessionTimeslot: 'select_preparation_session_timeslot',
    selectIntegrationSessionTimeslot: 'select_integration_session_timeslot',
    selectExperienceSessionTimeslot: 'select_experience_session_timeslot',
    selectRegularSessionTimeslot: 'select_regular_session_timeslot',
    rescheduleSession: 'reschedule_session',
    cancelSession: 'cancel_session',
    scheduleFirstSession: 'schedule_first_session',
    scheduleAllSession: 'schedule_all_session',
    scheduleMoreIndividualSession: 'schedule_more_individual_session',
    scheduleMultipleSessions: 'schedule_multiple_sessions_button',
    playExperienceAudio: 'play_experience_audio',
    playExperienceVideo: 'play_experience_video',
    readExperienceBlog: 'read_experience_blog',
    viewExperienceTravelChecklist: 'view_experience_travel_checklist',
    // Quest document upload events
    uploadQuestPolicy: 'upload_quest_policy',
    uploadQuestHeadshot: 'upload_quest_headshot',
    uploadQuestPassport: 'upload_quest_passport',
    uploadQuestTicket: 'upload_quest_ticket',
    // Quest enrollment process events
    startQuestEnrollment: 'start_quest_enrollment',
    viewQuestEnrollmentResponses: 'view_quest_enrollment_responses',
    submitQuestEnrollment: 'submit_quest_enrollment',
    // Schedule call events
    scheduleCall: 'schedule_call',
    // Experience payment button events
    continueExperiencePaymentMethod: 'continue_experience_payment_method',
    continueExperienceBillingInfo: 'continue_experience_billing_info',
    makeExperiencePayment: 'make_payment_experience',
  },
  category: {
    breakthroughModuleCategory: 'Breakthrough Module',
    resilienceModuleCategory: 'Resilience Module',
    mediaCategory: 'User like/dislike media',
    loginCategory: 'User Sign In successfully',
    signUpCategory: 'User Sign Up successfully',
    audioPlayerCategory: 'audioPlayer tracking',
    UserTakeAssessmentCategory: 'Take assessment by user',
    AddNewInsightCategory: 'Add new insight',
    AddNewIntentionCategory: 'Add new intention',
    singleMediaOfMuduleCategory: 'Module audio listen',
    journalDataSaveCategory: 'User save journal',
    helpCategory: 'submit User their Question',
    profileCategory: 'User update profile',
    resetPasswordCategory: 'User reset password successfully',
    resendEmailCategory: 'User click on resend email button',
    updatePasswordCategory: 'User update password successfully',
    compareAssessmentCategory: 'User compare two assessment',
    nextModuleCategory: 'User go to next module',
    learnMoreCategory: 'User click on learnMore botton',
    cookieCategory: 'User Accept Cookie',
    paymentCategory: 'User update plan',
    applyPromoCodeCategory: 'User apply promocode',
    ListenPSPAudioCategory: 'User listen attached audio',
    deleteIntentionCategory: 'User delete Intention',
    notificationsCategory: 'Click on notification icon',
    unreadNotificationsCategory: 'Read particular notification',
    laResultCategory: 'See leader assessment result',
    selectPendingLACategory: 'Select pending leader assessment',
    submitLARequestCategory: 'Send leader assessment request',
    submitReminderRequestCategory: 'Send Simple360 reminder request',
    submitLAReminderRequestCategory: 'Send leader reminder request',
    submitManagerRequestCategory: 'Send direct manager feedback request',
    submitReviewUpcomingQuestCategory: 'Send review of upcoming quest',
    sessionDetailsCategory: 'Open Session Details',
    sessionKeySkillsCategory: 'Download recommended key skills',
    userJourneysAudioCategory: 'Play individual coach recommends audio',
    // orgJourneysAudioCategory: 'Play organization journeys audio',
    groupJourneysAudioCategory: 'Play group coach recommends audio',
    practicalOrPoeticAudioCategory: 'Play practical or poetic audio',
    keySkillsCategory: 'Download key skills',
    moduleAudioCategory: 'Module audio like/dislike',
    favoritedAudioDislikeCategory: 'Favorited audio dislike',
    surveyCategoryDetailsCategory: 'Open survey category details',
    laLearnMoreBtnCategory: 'Open learn more modal',
    openAssessmentTypeformCategory: 'User open assessment typeform',
    upgradeButtonCategory: 'Click on upgrade button',
    openContinueProgramCategory: 'User open continue program from home page',
    openProgramCategory: 'Open program from programs page',
    playMediaLibraryAudioCategory: 'Play medialibrary audio',
    playFavoritedAudioCategory: 'Play favorited audio from favorite page',
    playLRAudioCategory: 'Play audio from learning resource',
    playLRVideoCategory: 'Play video from learning resource',
    packingListCategory: 'Download packing list',
    toggleSessionMediaBookmarkCategory:
      'Toggle session media bookmark on sessions page',
    toggleCoachRecommendsMediaBookmarkCategory:
      'Toggle journeys media bookmark on coach recommends page',
    toggleLRMediaBookmarkCategory:
      'Toggle journeys media bookmark on learning resource page',
    restoreIntentionCategory: 'Restore intention in growthPlan page',
    addIntentionCategory: 'Add intention in growthPlan page',
    archiveIntentionCategory: 'Archive Intention in growthPlan page',
    takeLeaderAssessmentCategory: `Click on 'New Leader Assessment' button`,
    openLARequestsSentUserModalCategory:
      'Open leader assessment requests sent user modal',
    playJournalMediaCategory: 'Play journal media',
    programEnrollBtnClickedCategory: `User clicked 'ENROLL IN YOUR PROGRAM' button`,
    togglePlayBarSizeCategory: 'User toggle playbar size',
    openMediaDescriptionCategory: 'Open media description from media player',
    bookCircleCategory: 'User clicked book circle button',
    selectCoachAndCircleTimeCategory:
      'User clicked coach and circle time button',
    scheduleSessionCategory: 'User clicked schedule session button',
    seeFullResultCategory: 'User clicked assessment see full result',
    readLearningResourceCategory: 'User clicked learning resource read tab',
    listenLearningResourceCategory: 'User clicked learning resource listen tab',
    watchLearningResourceCategory: 'User clicked learning resource watch tab',
    // Experience related categories
    openExperiencePageCategory: 'User open experience page',
    openYourExperiencePageCategory: 'User open your experience page',
    viewExperienceDetailsCategory: 'User view experience details',
    viewExperienceItineraryCategory: 'User view experience itinerary',
    viewExperiencePaymentCategory: 'User view experience payment',
    viewExperienceIntentionCategory: 'User view experience intention',
    viewExperienceOrientationCallCategory:
      'User view experience orientation call',
    viewExperienceBookIndividualSessionCategory:
      'User view experience book individual session',
    selectPreparationSessionTimeslotCategory:
      'User select preparation session timeslot',
    selectIntegrationSessionTimeslotCategory:
      'User select integration session timeslot',
    selectExperienceSessionTimeslotCategory:
      'User select experience session timeslot',
    selectRegularSessionTimeslotCategory:
      'User select regular session timeslot',
    rescheduleSessionCategory: 'User reschedule session',
    cancelSessionCategory: 'User cancel session',
    scheduleFirstSessionCategory: 'User schedule first session',
    scheduleAllSessionCategory: 'User schedule all session',
    scheduleMoreIndividualSessionCategory:
      'User schedule more individual session',
    scheduleMultipleSessionsCategory: 'User schedule multiple sessions',
    playExperienceAudioCategory: 'User play experience audio',
    playExperienceVideoCategory: 'User play experience video',
    readExperienceBlogCategory: 'User read experience blog',
    viewExperienceTravelChecklistCategory:
      'User view experience travel checklist',

    // Quest document upload categories
    uploadQuestPolicyCategory: 'User upload quest policy document',
    uploadQuestHeadshotCategory: 'User upload quest headshot document',
    uploadQuestPassportCategory: 'User upload quest passport document',
    uploadQuestTicketCategory: 'User upload quest ticket document',
    // Quest enrollment process categories
    startQuestEnrollmentCategory: 'User start quest enrollment process',
    viewQuestEnrollmentResponsesCategory:
      'User view quest enrollment responses',
    submitQuestEnrollmentCategory: 'User submit quest enrollment form',
    // Schedule call categories
    scheduleCallCategory: 'User submit schedule call form',
    // Experience payment button categories
    continueExperiencePaymentMethodCategory:
      'User continue experience payment method',
    continueExperienceBillingInfoCategory:
      'User continue experience billing info',
    makeExperiencePaymentCategory: 'User make experience payment',
  },
}
export default gtm
